/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withDLSTheme} from '../../theme/withDLSTheme';
import {TertiaryIconButton as CurrentTertiaryIconButton} from './current/TertiaryIconButton';
import {TertiaryIconButton as LegacyTertiaryIconButton} from './legacy/TertiaryIconButton';

// This is essential if a client imports the `TertiaryIconButton` component using
// `import {TertiaryIconButton} from ‘./TertiaryIconButton’;`
export const TertiaryIconButton = withDLSTheme(LegacyTertiaryIconButton, CurrentTertiaryIconButton);

export default TertiaryIconButton;
